// The dashboard navbar is sticky at z-index 1040 (TestDashboardNav.scss), well above
// Mantine's default modal z-index of 200, so a modal opened from a dashboard page
// renders underneath it. Modals have to clear the navbar, and any portalled dropdown
// inside a modal — a DateInput calendar, a Select — has to clear the modal in turn.
export const MODAL_Z_INDEX = 1100;
export const MODAL_POPOVER_Z_INDEX = 1200;
